const STORAGE_PREFIX = 'logami.experiment.';

export const LANDING_HERO_EXPERIMENT_ID = 'landing_hero_v1';
export const LANDING_HERO_VARIANTS = ['control', 'value_first'];
const LANDING_HERO_QUERY_PARAM = 'ab_landing';

function getStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch (_) {
    return null;
  }
}

function getQueryVariant(paramName, variants) {
  if (typeof window === 'undefined') return null;
  try {
    const value = new URLSearchParams(window.location.search).get(paramName);
    if (!value) return null;
    return variants.includes(value) ? value : null;
  } catch (_) {
    return null;
  }
}

function readAssignment(experimentId) {
  const storage = getStorage();
  if (!storage) return null;

  try {
    const raw = storage.getItem(`${STORAGE_PREFIX}${experimentId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.variant || null;
  } catch (_) {
    return null;
  }
}

function writeAssignment(experimentId, variant, source = 'random') {
  const storage = getStorage();
  if (!storage) return;

  try {
    storage.setItem(
      `${STORAGE_PREFIX}${experimentId}`,
      JSON.stringify({
        variant,
        source,
        assignedAt: new Date().toISOString(),
      })
    );
  } catch (_) {
    // Ignore storage failures in restricted browser environments.
  }
}

function pickVariant(variants) {
  const index = Math.floor(Math.random() * variants.length);
  return variants[index] || variants[0];
}

export function getAssignedVariant(experimentId) {
  return readAssignment(experimentId);
}

export function getOrAssignVariant(experimentId, variants, { queryParam } = {}) {
  const overrideVariant = queryParam ? getQueryVariant(queryParam, variants) : null;
  if (overrideVariant) {
    writeAssignment(experimentId, overrideVariant, 'query_override');
    return overrideVariant;
  }

  const assignedVariant = readAssignment(experimentId);
  if (assignedVariant && variants.includes(assignedVariant)) {
    return assignedVariant;
  }

  const variant = pickVariant(variants);
  writeAssignment(experimentId, variant, 'random');
  return variant;
}

export function getLandingHeroVariant() {
  return getOrAssignVariant(LANDING_HERO_EXPERIMENT_ID, LANDING_HERO_VARIANTS, {
    queryParam: LANDING_HERO_QUERY_PARAM,
  });
}

// ─── Landing Page A/B: full-page variant (control = original, variant_b = course-focused) ───
export const LANDING_PAGE_EXPERIMENT_ID = 'landing_page_v1';
export const LANDING_PAGE_VARIANTS = ['control', 'variant_b'];
const LANDING_PAGE_QUERY_PARAM = 'ab_page';

export function getLandingPageVariant() {
  // Experiment concluded: variant_b won. Always assign variant_b and persist
  // to localStorage so getAssignedVariant() picks it up for downstream events.
  return getOrAssignVariant(LANDING_PAGE_EXPERIMENT_ID, ['variant_b']);
}

